import { Auth } from "../../../Views/Auth/Auth";
import { AuthVersioningProps } from "core/hooks/useAuthVersioning";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { Login } from "../../../Views/Login/Login";
import { Logout } from "../Logout/Logout";
import { ProtectedRoute } from "../accessControl/ProtectedRoute/ProtectedRoute";
import { ReactElement, useCallback } from "react";
import { handleLogout } from "../Logout/handleLogout/handleLogout";
import { useAuth } from "./useAuth/useAuth";
import { useNavigate } from "react-router-dom";

const useAuthModules = (): AuthVersioningProps => {
  const auth = useAuth();
  const navigate = useNavigate();

  const updateClient = useCallback(() => {
    navigate("/login", { state: "change_org" });
  }, [navigate])

  return {
    auth: (sso?: boolean) => <Auth auth={auth} sso={sso} />,
    Login: () => <Login auth={auth} />,
    Logout: ({ type }: { type?: "nav" | "account" }) => {
      const logout = handleLogout(auth);

      return <Logout type={type} handleLogout={logout} />;
    },
    protect: (el: ReactElement): ReactElement => <ProtectedRoute auth={auth}>{el}</ProtectedRoute>,
    updateClient,
    handleSsoSetup: () => {
      auth.signinRedirect({ redirect_uri: `${window.location.origin}/auth/sso`, extraQueryParams: { client_code: ClientInfoState.getCode() } });
    },
  };
};

export const AuthModulesV1 = (): AuthVersioningProps => {
  const modules = useAuthModules();

  return modules;
};
